import _ from 'lodash';
import React from "react";
import PropTypes from 'prop-types';

import Text from "../Elements/Text";
import Image from "../Elements/Image";

import Container from "./Container";

export const backgroundStyles = {
    boxSizing: 'border-box',
    width: 400,
    height: 600,

    backgroundColor: '#fff',
//    backgroundPosition: 'center center',
//    backgroundImage: 'url("/img/funky-lines.png")',
};

export default class Slide extends React.Component
{
    static propTypes = {
        slide: PropTypes.object.isRequired,
        elements: PropTypes.array.isRequired,

        editable: PropTypes.bool,
        changeElement: PropTypes.func,
        currentElementId: PropTypes.string,
    };

    static defaultProps = {
        editable: false,
        currentElementId: null,
        changeElement: () => {}
    };

    onClick = (elementId) => {
        if (! this.props.editable) {
            return false;
        }

        this.props.changeElement(elementId);
    };

    render()
    {
        const { elements, slide } = this.props;
        const { currentElementId, editable, style } = this.props;

        const data = slide.data;

        const combinedStyles = {
            ...backgroundStyles,
            ...style,
            ...data
        };

        return <div className="shadow rounded relative bg-white overflow-hidden" style={combinedStyles}>
            {
                _.map(elements, element => {

                    if (element.slide_id !== slide.id) {
                        // @todo we shouldn't need to check if the element is within the slide
                        // We are doing this just now because we're hacking what's fetched from
                        // the store... and just returning every known element! :(

                        return;
                    }

                    const placement = {
                        left: element.x,
                        top: element.y,
                        width: element.width,
                        height: element.height,
                        position: element.position
                    };

                    const active = currentElementId === element.id;

                    return <Container
                        key={element.id}
                        id={element.id}
                        {...placement}
                        editable={editable}
                        active={active}
                        onClick={() => this.onClick(element.id)}
                    >
                        {this.renderElement(element)}
                    </Container>;
                })
            }
        </div>;
    }

    renderElement(element)
    {
        switch (element.type) {
            case 'text': {
                const {text, ...properties} = element.data;
                return <Text
                    editable={this.props.editable}
                    text={text}
                    properties={properties}
                />;
            }
            case 'image': {
                const properties = element.data;
                return <Image
                    editable={this.props.editable}
                    mediaId={element.data.media_id}
                    width={element.width}
                    height={element.height}
                    properties={properties}
                />;
            }
        }
    }
}
